<template>
  <div>
    
    <!-- === Data table === -->
      <v-card>
        <v-card-title>
          <v-btn rounded class="mr-5" depressed color="primary" @click="handleAdd()">
            <v-icon class="mr-1" dark> mdi-plus-circle</v-icon>
            {{ $t("addNew") }}
          </v-btn>

          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="listUnits"
          :search="search"
          hide-default-footer
          class="elevation-1"
          :server-items-length="totalPage"
          :items-per-page="itemsPerPage"
          :page.sync="currentPage"
          :options.sync="options"
          :mobile-breakpoint="0"
        >
          <!-- Progressive -->
          <template v-slot:progress><v-progress-circular indeterminate color="green" :value="50"></v-progress-circular></template>

          <!-- Header -->
          <template v-slot:header.actual_name="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.short_name="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.allow_decimal="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>
            
          <!-- Body -->
          <template v-slot:item.allow_decimal="{ item }">
            <v-chip outlined class="ma-2" :color="item.allow_decimal == 'yes' ? 'green' : 'orange' " small>
              {{ item.allow_decimal | capitalize }}
            </v-chip>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn color="primary" outlined class="table-action-button mr-2" text icon @click="handleEdit(item, $event)">
              <font-awesome-icon icon="edit"/>
            </v-btn>
            <v-btn color="error" outlined class="table-action-button" text icon
                  @click.native="handleRemove(item)">
              <font-awesome-icon icon="trash"/>
            </v-btn>
          </template>
        </v-data-table>

        <!-- Pagination -->
        <div class="text-center pt-2">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-col v-if="!$vuetify.breakpoint.xsOnly" class="d-flex" cols="12" sm="1"> {{ $t("total") }} : {{ totalPage }}</v-col>
            <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly"><v-select :label="$t('perPage')" v-model="itemsPerPage" :items="pageList"></v-select></v-col>
            <v-pagination
              v-model="currentPage"
              :length="pageCount"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
            ></v-pagination>
            <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
              <v-text-field
                v-model="currentPageComputed"
                :max="pageCount"
                min="1"
                type="number"
                :label="$t('goto')"
              ></v-text-field>
            </v-col>
          </v-card-actions>
        </div>
      </v-card>
    <!-- === End Data table === -->

    <!--=== Form add dialog section ==== -->
      <v-dialog v-model="dialog" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.mobile">
        <v-card>
          <v-card-title class="dialog-header">
            <span class="headline" v-if="toggleAdd">{{ $t("addUnit") }}</span>
            <span class="headline" v-if="!toggleAdd">{{ $t("editUnit") }}</span>
            <v-spacer></v-spacer>
            <v-btn
              fab
              text
              icon
              @click="dialog = false"
              valid="false"
              v-shortkey="['esc']"
              @shortkey.native="dialog = false"
            >
            <span class="white--text">
              <v-icon dark>
                mdi-close
              </v-icon>
            </span>
            </v-btn>
          
            </v-card-title>
              <v-card-text>
                <v-form v-model="valid" ref="formData">
                  <v-container>
                     <v-row :no-gutters="$vuetify.breakpoint.mobile">
                        <v-col cols="12">
                          <v-text-field
                            v-model="formDoc.actualName"
                            :label="$t('name') + '*'"
                            :rules="valueRules"
                            required
                            outlined
                            
                            dense
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field
                            v-model="formDoc.shortName"
                            :label="$t('shortName') + '*'"
                            :rules="valueRules"
                            required
                            outlined
                            
                            dense
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                           <v-radio-group
                              v-model="formDoc.allowDecimal"
                              row
                              :label="$t('allowDecimal') + '*'"
                              :rules="valueRules"
                              required
                              style="margin-top:-10px !important"
                            >
                              <v-radio label="No" name="allowDecimal" value="no"></v-radio>
                              <v-radio label="Yes" name="allowDecimal" value="yes"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>

                  </v-container>
                </v-form>
              </v-card-text>
            <v-card-actions>

            <v-spacer></v-spacer>
            <v-btn color="default" outlined text @click="dialog = false">
              {{ $t('close') }}
            </v-btn>
            <v-btn class="ma-2 v-btn v-btn--contained theme--light v-size--default success white--text" text @click="submit($event)">
              <font-awesome-icon icon="check-circle" class="mr-1"/>
              {{ $t('save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <!--=== End Form add dialog section ==== -->

  </div>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import mainMixin from "@/mixins/mainMixin";
import optionDataMixin from "@/mixins/optionDataMixin";
import axios from "axios";
import { provider } from "../../../service/provider";
import _ from "lodash";

export default {
  name: "Unit",
  mixins: [validatorMixin, mainMixin, optionDataMixin],
  data() {
    return {
      headers: [
        {
          text: "name",
          value: "actual_name",
          sortable: true,
        },
        { 
          text: "shortName", 
          value: "short_name",
          sortable: true, 
        },
        { 
          text: "allowDecimal", 
          value: "allow_decimal",
          sortable: true, 
         },
         { text: "action", value: "action", sortable: false, width: 115 }
      ],
      formDoc: {
        id: "",
        actualName: "",
        shortName: "",
        allowDecimal: "no"
      },
    };
  },
  mounted() {},
  methods: {
    reset() {
      if (this.$refs.formData) {
          this.$refs.formData.resetValidation();
          this.formDoc.id           = "";
          this.formDoc.actualName   = "";
          this.formDoc.shortName    = "";
          this.formDoc.allowDecimal = "no";
      }
    },

    handleAdd() {
        let vm = this;
        vm.reset();
        vm.dialog     = true;
        vm.toggleAdd  = true;
    },

    handleClose() {
        this.dialog = false;
        this.reset();
    },

    handleRemove(item) {
      let vm = this;
      vm.$confirm(vm.$t("thisWillDelete") + item.id + ' . ' + vm.$t('continue') + '?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        vm.removeTransaction(item.id);
      }).catch(() => {
        vm.$message({
          type: 'info',
          message: vm.$t('deleteCancel')
        });
      });
    },

    removeTransaction(id) {
      let vm = this;
      let url = provider.baseURL +  provider.destroyUnit;
      return new Promise((resolve, reject) => {
        axios.post(url, {id: id}, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                resolve(res.data.data);
                vm.$message({
                  type: 'success',
                  message: vm.$t('deleteComplete')
                });
                vm.fetchDataTable();
              }
            },
            error => {
              reject(error);
            }
        );
      });
    },

    handleEdit(item, event) {
      event.preventDefault();
      let vm        = this;
      vm.overlay    = true;
      vm.dialog     = true;
      vm.toggleAdd  = false;
    
      if(Object.keys(item).length){
        vm.formDoc.id           = item.id;
        vm.formDoc.actualName   = item.actual_name;
        vm.formDoc.shortName    = item.short_name;
        vm.formDoc.allowDecimal = item.allow_decimal;
      }
    },

    fetchDataTable: _.debounce(function () {
      let vm = this;
      vm.fetchTransactionUnit({
        search: vm.search,
        id: "",
        offset: vm.currentPage,
        limit: vm.itemsPerPage,
        sortBy: vm.options.sortBy[0] || "created_at",
        sortDesc: vm.options.sortDesc[0]===false ? 0 :1
      });
      
    }, 350),

    submit(e) {
      e.preventDefault();
      let vm = this;
      if (vm.$refs.formData.validate()) {
          vm.overlay = true;
          let url = provider.baseURL + provider.storeUnit;

          let params = {
            id: vm.formDoc.id,
            actual_name: vm.formDoc.actualName,
            short_name: vm.formDoc.shortName,
            allow_decimal: vm.formDoc.allowDecimal
          }
          return new Promise((resolve, reject) => {
              axios.post(url, params, {headers: {Authorization: localStorage.token}}).then(
                  res => {
                      if (res.data.response && res.data.response.code === 200) {
                          vm.$notify({
                              title: "Success",
                              message: vm.$t("success"),
                              type: "success",
                              duration: 700
                          });
                          vm.dialog = false;
                          vm.fetchDataTable();
                          vm.overlay=false;
                      }
                  },
                  error => {
                      reject(error);
                  }
              );
          });
      }
    }
  },
  created() {
    this.fetchDataTable();
  },
  computed:{},
  watch: {
    search() {
      this.fetchDataTable();
    },
    currentPage() {
      this.loading = true;
      this.fetchDataTable();
    },
    itemsPerPage() {
      this.loading = true;
      this.fetchDataTable();
    },
  }
};
</script>
